import React, { useState, useEffect } from 'react';
import './Valoracion.css';

const Valoracion = ({ profileId }) => {
  // URL de la API para obtener las preguntas
  const API_QUESTIONS_URL = `${process.env.REACT_APP_VALORACION_URL}/get_valoracion_questions.php`;
  // Estados principales
  const [preguntas, setPreguntas] = useState([]);
  const [respuestas, setRespuestas] = useState({});
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [loadingPreguntas, setLoadingPreguntas] = useState(true);

  // Cargar preguntas desde la base de datos al montar el componente
  useEffect(() => {
    cargarPreguntas();
  }, []);

  const cargarPreguntas = async () => {
    try {
      setLoadingPreguntas(true);
      const response = await fetch(API_QUESTIONS_URL);
      const data = await response.json();
      
      if (data.success) {
        setPreguntas(data.preguntas);
        // Inicializar respuestas vac�as
        const respuestasIniciales = {};
        data.preguntas.forEach(pregunta => {
          respuestasIniciales[pregunta.ID] = null;
        });
        setRespuestas(respuestasIniciales);
      } else {
        setMensaje('Error al cargar las preguntas: ' + data.error);
      }
    } catch (error) {
      console.error('Error al cargar preguntas:', error);
      setMensaje('Error de conexi�n al cargar las preguntas');
    } finally {
      setLoadingPreguntas(false);
    }
  };

  const handleNotaClick = (preguntaId, nota) => {
    setRespuestas(prev => ({
      ...prev,
      [preguntaId]: nota
    }));
  };

  const handleEnviarValoracion = async () => {
    // Validar que todas las preguntas tengan respuesta
    const todasRespondidas = preguntas.every(pregunta => respuestas[pregunta.ID] !== null);
    
    if (!todasRespondidas) {
      setMensaje('Por favor responde todas las preguntas antes de enviar');
      setTimeout(() => setMensaje(''), 3000);
      return;
    }

    setLoading(true);
    setMensaje('');

    try {
      // Obtener ID del usuario desde sessionStorage
      const ID_U_viewer = localStorage.getItem('userId');
      
      if (!ID_U_viewer) {
        setMensaje('Error: No se encontró sesión de usuario');
        setLoading(false);
        setTimeout(() => setMensaje(''), 3000);
        return;
      }

      // URL del API para insertar valoraciones
      const API_PUT_URL = `${process.env.REACT_APP_VALORACION_URL}/valoracion_put.php`;

      // Enviar cada valoración al backend
      const promesas = preguntas.map(pregunta => {
        const formData = new FormData();
        formData.append('ID_valoracion_question', pregunta.ID);
        formData.append('Nota', respuestas[pregunta.ID]);
        formData.append('ID_Perfil', profileId);
        formData.append('ID_U_viewer', ID_U_viewer);

        return fetch(API_PUT_URL, {
          method: 'POST',
          body: formData
        });
      });

      // Esperar a que todas las peticiones se completen
      const responses = await Promise.all(promesas);
      
      // Verificar todas las respuestas
      const resultados = await Promise.all(responses.map(r => r.json()));
      
      // Verificar si todas fueron exitosas
      const todasExitosas = resultados.every(r => r.success);
      
      if (todasExitosas) {
        // Mostrar overlay de éxito
        setMensaje('SUCCESS');
        
        // Limpiar respuestas
        const respuestasLimpiadas = {};
        preguntas.forEach(pregunta => {
          respuestasLimpiadas[pregunta.ID] = null;
        });
        setRespuestas(respuestasLimpiadas);
        
        // Ocultar overlay después de 3 segundos
        setTimeout(() => setMensaje(''), 3000);
      } else {
        // Verificar si alguna falló por restricción de "ya valoraste hoy"
        const yaValorado = resultados.some(r => 
          r.message && r.message.includes('YA VALORASTE')
        );
        
        if (yaValorado) {
          setMensaje('YA VALORASTE HOY. Debes esperar hasta mañana para valorar nuevamente.');
        } else {
          setMensaje('Error: Algunas valoraciones no se pudieron guardar');
        }
        
        setTimeout(() => setMensaje(''), 4000);
      }
      
    } catch (error) {
      console.error('Error al enviar valoraciones:', error);
      setMensaje('Error de conexión al enviar las valoraciones');
      setTimeout(() => setMensaje(''), 3000);
    } finally {
      setLoading(false);
    }
  };

  if (loadingPreguntas) {
    return (
      <div className="valoracion-container">
        <div className="valoracion-header">
          <h3 className="valoracion-title">Valoraci�n</h3>
        </div>
        <div className="loading-message">
          <i className="fas fa-spinner fa-spin"></i> Cargando preguntas...
        </div>
      </div>
    );
  }

  if (preguntas.length === 0) {
    return (
      <div className="valoracion-container">
        <div className="valoracion-header">
          <h3 className="valoracion-title">Valoraci�n</h3>
        </div>
        <div className="no-preguntas">
          No hay preguntas de valoraci�n disponibles en este momento.
        </div>
      </div>
    );
  }

  return (
    <div className="valoracion-container">
      <div className="valoracion-header">
        <h3 className="valoracion-title">Valoraci�n</h3>
      </div>

      {/* T�tulo instructivo con borde cyan */}
      <div className="valoracion-instrucciones">
        <h2 className="instrucciones-title">
          Entrega tu nota, respecto a las siguientes preguntas :
        </h2>
      </div>

      {/* Secci�n de preguntas */}
      <div className="preguntas-container">
        {preguntas.map((pregunta) => (
          <div key={pregunta.ID} className="pregunta-item">
            <h3 className="pregunta-texto">{pregunta.preguntas}</h3>
            <div className="notas-container">
              {[1, 2, 3, 4, 5, 6, 7].map((nota) => (
                <button
                  key={nota}
                  className={`nota-btn ${nota <= 3 ? 'nota-baja' : 'nota-alta'} ${
                    respuestas[pregunta.ID] === nota ? 'selected' : ''
                  }`}
                  onClick={() => handleNotaClick(pregunta.ID, nota)}
                >
                  {nota}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Bot�n de env�o */}
      <div className="enviar-container">
        <button 
          className="enviar-valoracion-btn"
          onClick={handleEnviarValoracion}
          disabled={loading}
        >
          {loading ? 'Enviando...' : 'Enviar'}
        </button>
      </div>

      {/* Mensaje de feedback */}
      {mensaje && mensaje !== 'SUCCESS' && (
        <div className={`mensaje-valoracion ${mensaje.includes('Error') || mensaje.includes('YA VALORASTE') ? 'error' : 'success'}`}>
          {mensaje}
        </div>
      )}

      {/* Overlay de éxito */}
      {mensaje === 'SUCCESS' && (
        <div className="overlay-exito">
          <div className="overlay-exito-content">
            <div className="overlay-exito-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <h2 className="overlay-exito-title">¡VALORACIÓN EXITOSA!</h2>
            <p className="overlay-exito-subtitle">GRACIAS!!!</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Valoracion;
